<template>
    <div class="invoice-files-view detail-card">
        <div v-if="!createMode" class="card-header">
            <div class="title">
                <div>檢附文件</div>
                <div style="font-size: 9pt; font-weight: normal; color: #aaa;">(合約、報價單、手開發票留存、作廢發票留存)</div>
            </div>
            <el-button v-if="form.status !== 5 && !isQR()" style="margin-left: 10px; color: #888" size="mini" @click="onAdd">
                新增文件
            </el-button>
        </div>
        <div v-else class="create-mode-header">
            <el-button v-if="!isQR()" style="margin-bottom: 10px; color: #888" size="mini" @click="onAdd">
                新增文件
            </el-button>
        </div>
        <div class="card-body">
            <el-table :data="data" empty-text="無資料">
                <el-table-column prop="filE_ATT" width="150" label="檔案">
                    <template slot-scope="scope">
                        <div v-if="scope.row.filE_ATT">
                            <el-image v-if="getAttTyp(scope.row.filE_ATT) !== 'pdf'" style="width: 100%; border: 1px solid #ccc" :src="scope.row.filE_ATT" :previewSrcList="[scope.row.filE_ATT]">
                            </el-image>
                            <ahFileIcon v-else ext="pdf" :url="scope.row.filE_ATT" />
                        </div>
                        <div v-else>(無)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="nam" label="文件名稱／備註">
                    <template slot-scope="scope">
                        <div class="file-name">{{ scope.row.nam }}</div>
                        <div class="file-note">{{ scope.row.note }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="updateUser" label="上傳人" width="120">
                    <template slot-scope="scope">
                        <div>{{ scope.row.updateUser }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="updateUser" label="上傳日期" width="110">
                    <template slot-scope="scope">
                        <div>{{ scope.row.updateTime | dateFormater("YYYY-MM-dd") }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="action" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-dropdown v-if="!isQR()" @command="onMoreDropdownClick($event, scope.row, scope.$index)">
                            <el-button size="mini">
                                <i class="el-icon-more" />
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="edit">編輯</el-dropdown-item>
                                <el-dropdown-item command="remove">刪除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <InvoiceFilesEditDialog
            :visible="invoiceFilesEditDialog.visible"
            :createMode="createMode"
            :invoiceSno="form.sno"
            :editForm="invoiceFilesEditDialog.form"
            @close="onInvoiceFilesEditDialogClose"
            @create="onCreate"
            @remove="onRemove"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import InvoiceFilesEditDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog/InvoiceFilesEditDialog.vue';
import ahFileIcon from '@/components/ui/ahFileIcon.vue';

export default {
    components: { InvoiceFilesEditDialog, ahFileIcon },
    props: {
        form: {
            type: Object,
            default: () => {},
        },
        createMode: Boolean,
    },
    data() {
        return {
            invoiceFilesEditDialog: { visible: false, form: null },
            editIndex: null,

            deleteSnos: [],
        };
    },
    computed: {
        data() {
            return _.map(this.form.invoiceFiles, (o) => ({
                ...o,
                updateUser: o.updateUser,
                updateTime: o.updateTime,
            }));
        },
    },
    methods: {
        onAdd() {
            this.invoiceFilesEditDialog.visible = true;
        },
        onInvoiceFilesEditDialogClose(reload) {
            this.invoiceFilesEditDialog.visible = false;
            this.invoiceFilesEditDialog.form = null;
            this.editIndex = null;
            if (reload) this.$emit('reload');
        },
        async onMoreDropdownClick(command, row, index) {
            console.log(command, row, index);
            if (command === 'edit') {
                this.invoiceFilesEditDialog.form = row;
                this.invoiceFilesEditDialog.visible = true;
                this.editIndex = index;
            } else if (command === 'remove') {
                try {
                    await this.$confirm('確定要刪除此文件？', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    });
                    await this.onRemove(row.sno);
                } catch (e) {
                    console.log(e);
                }
            }
        },

        async onRemove(sno) {
            if (this.createMode) {
                this.data.splice(this.editIndex, 1);
                this.$emit(
                    'change',
                    _.map(this.data, (o) => ({
                        sno: o.sno,
                        filE_ATT: o.filE_ATT,
                        nam: o.nam,
                        note: o.note,
                        invoiceSno: null,
                        updateUser: o.updateUser,
                        updateTime: o.updateTime,
                    })),
                );
                if (sno) this.deleteSnos.push(sno);
                return;
            }

            await this.$api({
                url: '/InvoiceManagemnetPage/CancelInvoiceFiles',
                method: 'POST',
                data: { sno },
            });
            this.$message({
                showClose: true,
                message: '已刪除文件',
                type: 'success',
            });
            this.$emit('reload');
        },

        onCreate(item) {
            const EXIST = item.sno && _.findIndex(this.data, ['sno', item.sno]);

            if (this.editIndex !== null) this.data.splice(this.editIndex, 1, item);
            else if (EXIST) this.data.splice(EXIST, 1, item);
            else this.data.push(item);

            this.$emit(
                'change',
                _.map(this.data, (o) => ({
                    sno: o.sno,
                    filE_ATT: o.filE_ATT,
                    nam: o.nam,
                    note: o.note,
                    invoiceSno: null,
                    updateUser: o.updateUser,
                    updateTime: o.updateTime,
                })),
            );
        },

        getAttTyp(fileAtt) {
            return fileAtt
                ?.split('.')
                .pop()
                .toLowerCase();
        },
        async executeDeleteFiles() {
            const QUEUE = [];
            this.deleteSnos.forEach(async (sno) => {
                QUEUE.push(
                    this.$api({
                        url: '/InvoiceManagemnetPage/CancelInvoiceFiles',
                        method: 'POST',
                        data: { sno },
                    }),
                );
            });

            await Promise.all(QUEUE);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.invoice-files-view {
    .create-mode-header {
        display: flex;
        justify-content: flex-end;
    }
    .file-name {
        color: $main-color;
    }
    .file-note {
        font-size: 10pt;
        color: #888888;
    }
}
</style>
